import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgFloorPipeModule } from 'angular-pipes';

import { TimeDifferencePipe } from './time-difference.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { DateAgoPipe, SafeHtmlPipe } from '../nenomed-main/Pipes/DateAgo.pipe';
import { MarkdownPipe } from './safehtml.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NgFloorPipeModule
  ],
  declarations: [
    TimeDifferencePipe,
    TimeAgoPipe,
    DateAgoPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    MarkdownPipe
  ],
  exports: [
    NgFloorPipeModule,
    TimeDifferencePipe,
    TimeAgoPipe,
    DateAgoPipe,
    SafeUrlPipe,
    SafeHtmlPipe,
    MarkdownPipe
  ]
})
export class PipesModule {}
